module.exports = __webpack_public_path__ + "mainassets/img/arrow-up.5ed80a3f.png";